export const UMB_ENTITY_IS_NOT_TRASHED_CONDITION_ALIAS = 'Umb.Condition.EntityIsNotTrashed';
